import {
  NumberInput,
  NumberInputField,
  NumberInputProps,
} from "@chakra-ui/react";
import React from "react";
import { BaseFieldProps, FieldWrapper } from "../FieldWrapper/FieldWrapper";

interface DecimalFieldProps extends BaseFieldProps {
  decimalPlaces?: number;
}

const parseValue = (value: string) => {
  const parsed = value.replace(/[\$,]/g, "");

  if (parsed === "") {
    return "";
  }

  return parsed;
};

export const DecimalField = ({
  name,
  label,
  id,
  horizontal,
  labelProps,
  valueProps,
  decimalPlaces,
  ...numberInputProps
}: DecimalFieldProps & Omit<NumberInputProps, "precision">) => {
  const precision = decimalPlaces !== undefined ? decimalPlaces : 2;
  const step =
    decimalPlaces !== undefined ? Math.pow(10, -decimalPlaces) : 0.01;

  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      horizontal={horizontal}
      labelProps={labelProps}
      valueProps={valueProps}
    >
      {({ field, form }) => {
        const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
          // Format the value on blur if it's a valid number
          const currentValue = field.value;
          if (
            currentValue !== "" &&
            currentValue !== undefined &&
            currentValue !== null
          ) {
            const numValue = Number(currentValue);
            if (
              !isNaN(numValue) &&
              decimalPlaces !== undefined &&
              decimalPlaces >= 0
            ) {
              // Store as a string with fixed decimal places to preserve trailing zeros
              const formatted = numValue.toFixed(decimalPlaces);
              form.setFieldValue(field.name, formatted, true);
            }
          }
          field.onBlur(e);
        };

        return (
          <NumberInput
            precision={precision}
            step={step}
            value={field.value != null ? field.value : undefined}
            onChange={(strValue) => {
              form.setFieldValue(field.name, parseValue(strValue), true);
            }}
            onBlur={handleBlur}
            name={field.name}
            backgroundColor="white"
            w="100%"
            {...numberInputProps}
          >
            <NumberInputField placeholder={numberInputProps.placeholder} />
          </NumberInput>
        );
      }}
    </FieldWrapper>
  );
};
